import { Button, ButtonProps, Icon, IconName } from '@infotech-soe/erp-ui-kit';
import classNames from 'classnames';
import React, { memo, useRef, useState } from 'react';

import AccountMenu from './AccountMenu';
import ConnectionIndicatorContainer from './ConnectionIndicatorContainer';
import { MainViewContainerProps } from './MainViewContainer';

type AccountMenuButtonProps = Pick<ButtonProps, 'className'> &
  Pick<MainViewContainerProps, 'userName'>;

const AccountMenuButton = ({
  className,
  userName,
}: AccountMenuButtonProps): React.JSX.Element => {
  const [showMenu, setShowMenu] = useState(false);
  const buttonRef = useRef<HTMLButtonElement>(null);

  return (
    <>
      <Button
        className={classNames('m-px-xs', className)}
        ref={buttonRef}
        rounded={false}
        variant="ondark"
        onClick={() => setShowMenu(!showMenu)}
      >
        <ConnectionIndicatorContainer />
        <Icon name="account" size={24} />
        <span className="m-px-sm">{userName}</span>
        <Icon name={`${showMenu ? '' : 'un-'}collapse` as IconName} size={16} />
      </Button>

      <AccountMenu
        open={showMenu}
        referenceElement={buttonRef.current}
        onOpenChange={setShowMenu}
      />
    </>
  );
};

export default memo(AccountMenuButton);
